<div
  style="display: flex; align-items: center !important; justify-content: center; height: 100vh; margin: 0; padding: 0; overflow-y: auto; background-image: url({{
    backgroundImage
  }}); background-color: white; 
background-size: cover; background-position: center center; background-repeat: repeat;"
>
  <div [class.container]="!hideContainer" class="pb-3" style="height: 100vh">
    <div
      class="login-container"
      style="display: flex; justify-content: center; height: 100%"
    >
      <mat-card
        class="mat-elevation-z8 m-3"
        style="background-color: rgba(232, 240, 254)"
      >
        <mat-card-content class="mb-0 p-5">
          <div class="mb-5 d-flex justify-content-center">
            <div>
              <img
                src="/assets/images/pointer_light.svg"
                style="height: 96px; width: auto"
              />
            </div>
          </div>

          <div class="row text-center">
            <div class="col-12">
              <a
                mat-flat-button
                style="width: 200px"
                [href]="login()"
                color="primary"
                [disabled]="logingIn"
              >
                <div class="d-flex justify-content-between align-items-center">
                  @if (!logingIn) {
                    <i class="fas fa-arrow-right me-2"></i>
                  }
                  @if (logingIn) {
                    <mat-spinner
                      class="me-2"
                      diameter="20"
                      color="accent"
                    ></mat-spinner>
                  }
                  &nbsp;{{ logingIn ? "Acessando" : "Acessar" }}
                </div>
              </a>
            </div>

            <div class="col-12 mt-3">
              <a tabindex="1" [routerLink]="['/help']">
                <!-- <mat-icon [inline]="true">help_outline</mat-icon> Help -->
                <i class="fal fa-circle-question"></i> Help
              </a>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
